/* eslint-disable */

import { Link } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { StyledFooter, StyledMobileFooter } from './Footer.styles';
import AppLogo from '../AppLogo';
import SocialIcons from '../SocialIcons';
import useSubdomain from '../../utils/useSubdomain';


const Links = ({ className, links }: { className: string, links: Array<{ link: string, title: string }> }) => {
  return (
    <div className={className}>
      {links.map((item, index) => (
        <Link
          key={index}
          to={item.link}
          className="styled-footer__link"
          onClick={(e) => {
            if (item.link.startsWith('mailto:') || item.link.startsWith('https:')) {
              window.location.href = item.link;
              e.preventDefault();
            }
          }}
        >
          {item.title}
        </Link>
      ))}
    </div>
  )
};

const Title = ({ className, title }: { className: string, title: string }) => {
  return (
    <div className="center-curve-container">
      <p className={className}>
        {title}
      </p>
    </div>
  )
}

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { config } = useSubdomain();
  const footerTitle = config.footerTilte
  const footerLinks = config.footerLinks
  return (
    <>
      {isMobile ? (
        <StyledMobileFooter>
          <div className="container">
            <AppLogo className="logo-container" />
            <Links className="links-container" links={footerLinks} />
            <SocialIcons className="social-media-icons-container" />
            <Title className="footer-label-text" title={footerTitle} />
          </div>
        </StyledMobileFooter>
      ) : (
        <StyledFooter>
          <div className="container">
            {/* <AppLogo className="left-logo-container" /> */}
            <Title className="center-curve-container-text" title={footerTitle} />
            <SocialIcons className="social-media-icons-right-container" />
            <Links className="links-container" links={footerLinks} />
          </div>
        </StyledFooter>
      )
      }
    </>
  );
};

export default Footer;
